module.exports = __webpack_public_path__ + "img/crown.5c0e9ab0.svg";